export class CreateInquilinoRequest {
  
    public idPersona : number=0;
}